
import { captureMessage } from '@sentry/browser'
import axios, { AxiosInstance } from 'axios'
import { API_TIMEOUT, FULLTIME_PARTNER_ID_KEY, FULLTIME_PARTNER_TOKEN_KEY } from '../utils/constants/constants'
import { logoutUser } from '../utils/helpers/utils'
import { isAuthOptionalPage } from '../utils/helpers/partner-utils'

const axiosInstance: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-type': 'application/json',
        'accept-language': localStorage.getItem('i18nextLng')?.includes('en') ? 'en' : 'ar',
        'fulltime-partner-id': localStorage.getItem(FULLTIME_PARTNER_ID_KEY),
        'Authorization': localStorage.getItem(FULLTIME_PARTNER_TOKEN_KEY) ? `Bearer ${localStorage.getItem(FULLTIME_PARTNER_TOKEN_KEY)}` : null,
        'app-source': 'PWA'
    },
    timeout: API_TIMEOUT,
    withCredentials: false,
})

axiosInstance.interceptors.request.use(
    (config: any) => {
        if (!config.headers.Authorization && localStorage.getItem(FULLTIME_PARTNER_TOKEN_KEY)) {
            config.headers.Authorization = `Bearer ${localStorage.getItem(FULLTIME_PARTNER_TOKEN_KEY)}`
        }
        if (!config.headers[FULLTIME_PARTNER_ID_KEY]) {
            config.headers[FULLTIME_PARTNER_ID_KEY] = localStorage.getItem(FULLTIME_PARTNER_ID_KEY)
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

axiosInstance.interceptors.response.use((response) => response,
    async (error) => {
        const httpStatusCode = error?.response?.status;
        const errorString = JSON.stringify({ report: `Received ${httpStatusCode} from backend`, error: { ...error?.response?.data?.error }, partnerId: localStorage.getItem(FULLTIME_PARTNER_ID_KEY) });

        if (httpStatusCode === 401 && !isAuthOptionalPage()) {
            logoutUser();
        }

        if (httpStatusCode === 400) {
            captureMessage(errorString);
        }

        if (httpStatusCode === 403) {
            setTimeout(() => {
                captureMessage(errorString);
                // logoutUser();
            }, 5000);
        }

        const data = error?.response?.data as Record<string, unknown> | undefined
        const apiError = data?.error
        let rejected: unknown = apiError

        if (apiError != null && typeof apiError === "object" && !Array.isArray(apiError)) {
            const merged = { ...(apiError as Record<string, unknown>) }
            const siblingDetails = data && "details" in data ? data.details : undefined
            if (siblingDetails !== undefined && merged.details === undefined) {
                merged.details = siblingDetails
            }
            rejected = merged
        }

        return Promise.reject(rejected)
    });

export default axiosInstance;